import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Select } from 'tea-component';
import type { SingleCommonType } from '../../types';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { commonBackInfo } from '../../utils';
import {
  logicOptionsFn,
  logicTextMap,
} from '../../constants/regionAndLanguage';
import './index.scss';
import { addFilterBuriedPoint } from '../../utils/point';
import { AllFilterPointType } from '@op/operationLog/pages/filter';
import { useSetStringDefaultValue } from '../../hooks/init';

export default function LogicSelect({
  changeOnCloseWindow,
  onChange,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  defaultKey = 'logic',
  lang,
  pointKey = 'RegionWithLanguage',
}: SingleCommonType & { pointKey?: AllFilterPointType }) {
  const {
    value: logic,
    setValue: setLogic,
    diffClassName,
  } = useSetStringDefaultValue({
    defaultValue,
    filterValue,
    defaultKey: defaultKey,
    initValue: 'and',
    oriDefaultFilter,
    backOriDefaultValue,
  });

  useEffect(() => {
    onChange?.(
      defaultKey,
      commonBackInfo({ [defaultKey]: logic }, { [defaultKey]: logic }),
    );
    changeOnCloseWindow?.({ [defaultKey]: logic });
  }, [logic]);

  const logicOptions = useMemo(() => {
    return logicOptionsFn(logic, lang);
  }, [logic, lang]);

  const buttonElement = useMemo(() => {
    const item = logicTextMap[logic as 'or' | 'and'];
    return (
      <div className="dbo-logic-select">
        <SvgIcon type={item.type} className="dbo-logic-select-icon" />
        <span>{item[lang]}</span>
      </div>
    );
  }, [logic, lang]);

  return (
    <Select
      appearance="button"
      className={`dbo-logic-select-wrapper  ${diffClassName}`}
      matchButtonWidth
      value={logic}
      boxClassName={`dbo-logic-dropdown-wrapper`}
      onChange={(value) => {
        setLogic(value);
        addFilterBuriedPoint(pointKey, value);
      }}
      options={logicOptions}
      button={buttonElement}
    />
  );
}
